import * as yup from 'yup'
import { createDataSchema, createPropertiesSchema, createWeakDataRef } from '../schemaUtils'

const policyType = yup
	.object({
		enabled: yup.boolean(),
		link: yup.string(),
	})
	.notRequired()

export const dataSchema = createDataSchema(
	'Document',
	yup.object({
		mainPage: createWeakDataRef('Page'),
		mainPageId: yup.string().default(''),
		renderModifiers: yup.object({ siteWidth: yup.number() }),
		characterSets: yup.array(yup.string()),
		accessibilitySettings: yup.object({
			visualFocusDisabled: yup.boolean(),
			skipToContent: yup.boolean(),
		}),
		layoutSettings: yup.object({
			headerToPagesGap: yup.string(),
			pagesToFooterGap: yup.string(),
		}),
		smSettings: yup.object({
			socialLoginGoogleEnabled: yup.boolean(),
			socialLoginFacebookEnabled: yup.boolean(),
			joinCommunityCheckedByDefault: yup.boolean().notRequired(),
			customNoPermissionsPageId: yup.string().notRequired(),
			customSignUpPageId: yup.string().notRequired(),
			customSignInPageId: yup.string().notRequired(),
			smFirstDialogLogin: yup.boolean().notRequired(),
			termsOfUse: policyType,
			privacyPolicy: policyType,
			codeOfConduct: policyType,
		}),
	})
)

export const propertiesSchema = createPropertiesSchema(
	'PageGroupProperties',
	yup.object({
		transition: yup
			.mixed<'none' | 'swipeHorizontalFullScreen' | 'swipeVerticalFullScreen' | 'crossfade' | 'outIn'>()
			.oneOf(['none', 'swipeHorizontalFullScreen', 'swipeVerticalFullScreen', 'crossfade', 'outIn'])
			.default('swipeHorizontalFullScreen'),
	})
)
